import { Patient } from './patient';
import { User } from './user';

export interface ClinicalNote {
  id: string;
  patient: Patient;
  content: string;
  createdBy: User;
  updatedBy: User;
  createdAt: string;
  updatedAt: string;
  isPinned: boolean;
  source: string;
  isArchived: boolean;
}

export interface GetClinicalNotesRequest {
  readonly patientId: string;
  readonly page?: number;
  readonly limit?: number;
}

export interface GetClinicalNotesResponse {
  notes: Array<ClinicalNote>;
  count: number;
}

export interface GetPinnedNotesAndTotalCountRequest {
  readonly patientId: string;
}

export interface GetPinnedNotesAndTotalCountResponse {
  pinnedNotes: Array<ClinicalNote>;
  count: number;
}

export enum NoteSource {
  INTERNAL = 'internal',
  SALESFORCE = 'salesforce'
}

export interface CreateNoteRequest {
  patientId: string;
  content: string;
  source?: NoteSource | null;
}

export interface CreateNoteResponse {
  id: string;
}

export interface UpdateNoteRequest {
  patientId: string;
  noteId: string;
  content?: string | null;
  isPinned?: boolean | null;
}

export interface UpdateNoteResponse {
  updatedNote: ClinicalNote;
}

export interface DeleteNoteRequest {
  patientId: string;
  noteId: string;
}

export interface DeleteNoteResponse {
  success: boolean;
}

export interface ArchiveNoteRequest {
  patientId: string;
  noteId: string;
}

export interface ArchiveNoteResponse {
  success: boolean;
}

export interface UnArchiveNoteRequest {
  patientId: string;
  noteId: string;
}

export interface UnArchiveNoteResponse {
  success: boolean;
}
